import { createApp } from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store/store';
import './assets/scss/main.scss';
import { helpersPlugin } from './plugins';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
library.add(fas);
import { fab } from '@fortawesome/free-brands-svg-icons';
library.add(fab);
import { far } from '@fortawesome/free-regular-svg-icons';
library.add(far);
import { dom } from '@fortawesome/fontawesome-svg-core';
dom.watch();
import Toast, { PluginOptions } from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import { createAuth0 } from '@auth0/auth0-vue';
import config from '@/config';
import { twoDecimal } from './utils/directives/twoDecimals.directive';
import { datadogRum } from '@datadog/browser-rum';

datadogRum.init({
  applicationId: '1807b994-1055-4e34-820f-1d7a732942b6',
  clientToken: 'pub68aa955d70316a02a9ef69a75d2fca7e',
  site: 'datadoghq.com',
  service: 'pricing-engine',
  env: config.appEnv,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 100,
  defaultPrivacyLevel: 'allow',
  allowedTracingUrls: [
    'http://localhost:5003',
    'https://api.engine.dev.viaphoton.dev',
    'https://api.engine.stage.viaphoton.dev',
    'https://pricing-engine.viaphoton.com',
  ],
  trackResources: true,
  trackLongTasks: true,
  trackUserInteractions: true,
});

// Vuetify
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import '@mdi/font/css/materialdesignicons.css';

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#f88d2a', // brand orange — same value as DaisyUI `primary` and --vp-primary
          secondary: '#363062',
        },
      },
    },
  },
});

const options: PluginOptions = {
  transition: 'Vue-Toastification__fade',
  maxToasts: 5,
  newestOnTop: true,
};

export const auth0 = createAuth0({
  domain: config.auth0.domain,
  clientId: config.auth0.clientId,
  useRefreshTokens: false,
  cacheLocation: 'localstorage',
  cookieDomain: config.auth0.cookieDomain,
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: config.auth0.audience,
    scope: 'openid profile email',
  },
});

createApp(App)
  .component('font-awesome-icon', FontAwesomeIcon)
  .directive('two-decimal', twoDecimal)
  .use(Toast, options)
  .use(store)
  .use(helpersPlugin)
  .use(router)
  .use(auth0)
  .use(vuetify)
  .mount('#app');
